import DeleteIcon from '@material-ui/icons/Delete';
import BusinessIcon from '@material-ui/icons/Business';
import PeopleIcon from '@material-ui/icons/People';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {selectAreas, storeAreas} from '../slices/profile';
import {deleteArea, deleteCompanyRm, getCompanyAreasListener} from "../api/company";
import './Sidebar.scss';
import {openDialog} from '../slices/dialog';
import {ConfirmAction} from './CommonComponents';
import {resetSelectedArea, resetSelectedRm, storeSelectedArea, storeSelectedRmId} from '../slices/selected';
import gsap from 'gsap'
import {useTranslation} from 'react-i18next';
import {ROUTES} from '../db/models/const';

export const CompanySidebar = () => {
    const dispatch = useDispatch();
    const areas = useSelector(selectAreas);
    const history = useHistory();
    const {t} = useTranslation();

    const onRmClick = (area, rmId) => {
        dispatch(storeSelectedArea({area}));
        dispatch(storeSelectedRmId({rmId}));
        closeSidebar();
        history.push(ROUTES.COMPANY_RM);
    };

    const onRmDelete = (event, rmId, areaId) => {
        event.stopPropagation();
        const action = () => deleteCompanyRm(rmId, areaId).then(() => {
            dispatch(resetSelectedRm());
            history.push(ROUTES.ME)
        });

        dispatch(openDialog({
            Content: ConfirmAction,
            title: "Conferma",
            props: {
                action,
            },
            closable: false
        }))
    }

    const onAreaDelete = (area) => {
        dispatch(resetSelectedArea());
        const action = () => deleteArea(area).then(() => history.push(ROUTES.ME))
            .catch(error => console.error(error))
            
        dispatch(openDialog({
            Content: ConfirmAction,
            title: "Conferma",
            props: {
                action
            },
            closable: false
        }))
    };

    const closeSidebar = () => {
        if (window.innerWidth > 768) return;
        const tl = gsap.timeline()
        tl
            .to('.sidebar', {duration: 0.1, xPercent: -100})
            .set('.sidebar', {display: 'none', xPercent: -100});
    }

    const onSelect = (url) => {
        closeSidebar();
        history.push(url);
    }

    useEffect(() => {
        const unsubscribe = getCompanyAreasListener({
            next: (snapshot) => {
                const areas = snapshot.docs.map((doc) => doc.data());
                dispatch(storeAreas(areas));
            },
        });
        return unsubscribe;
    }, [dispatch]);

    return (
        <section className="sidebar">
            <div className="sidebar__item1" onClick={() => onSelect(ROUTES.PROFILE)}>
                <BusinessIcon/>
                <p>{t("company_sidebar_profile")}</p>
            </div>
            <div className="sidebar__item1" onClick={() => onSelect(ROUTES.ME)}>
                <PeopleIcon/>
                <p>{t("company_sidebar_vivaio")}</p>
            </div>
            {areas.map((area, areaIndex) => (
                <div key={area.id} className="sidebar__item2">
                    <p className={"fw-bold"}>{area.name}</p>
                    <div className="sidebar__item2Delete" onClick={() => onAreaDelete(area)}><DeleteIcon/></div>
                    {Object.values(area.rms || {}).map((rm) => (
                        <div key={rm.id} className="sidebar__item3" onClick={() => onRmClick(area, rm.id)}>
                            <p>{rm.name}</p>
                            <div className="sidebar__item3Delete" onClick={(e) => onRmDelete(e, rm.id, area.id)}>
                                <DeleteIcon/></div>
                        </div>
                    ))}
                </div>
            ))}
        </section>
    )
}

export default CompanySidebar